import { useEffect } from 'react'

const SITE_URL = 'https://emwhellmotorsport.com'
const DEFAULT_IMAGE = `${SITE_URL}/assets/hero-action.jpg`

type SeoOptions = {
  title: string
  description: string
  path: string
  image?: string
  noindex?: boolean
}

function setMetaContent(selector: string, content: string) {
  document.head.querySelector(selector)?.setAttribute('content', content)
}

function setLinkHref(selector: string, href: string) {
  document.head.querySelector(selector)?.setAttribute('href', href)
}

export function useSeo({ title, description, path, image, noindex = false }: SeoOptions) {
  useEffect(() => {
    const url = `${SITE_URL}${path}`
    const resolvedImage = image ? (image.startsWith('http') ? image : `${SITE_URL}${image}`) : DEFAULT_IMAGE
    const previousTitle = document.title

    document.title = title
    setMetaContent('meta[name="description"]', description)
    setLinkHref('link[rel="canonical"]', url)
    setMetaContent('meta[property="og:title"]', title)
    setMetaContent('meta[property="og:description"]', description)
    setMetaContent('meta[property="og:url"]', url)
    setMetaContent('meta[property="og:image"]', resolvedImage)
    setMetaContent('meta[name="twitter:title"]', title)
    setMetaContent('meta[name="twitter:description"]', description)
    setMetaContent('meta[name="twitter:image"]', resolvedImage)

    let robotsTag = document.head.querySelector('meta[name="robots"]')
    if (noindex) {
      if (!robotsTag) {
        robotsTag = document.createElement('meta')
        robotsTag.setAttribute('name', 'robots')
        document.head.appendChild(robotsTag)
      }
      robotsTag.setAttribute('content', 'noindex, nofollow')
    } else if (robotsTag) {
      robotsTag.remove()
    }

    return () => {
      document.title = previousTitle
    }
  }, [title, description, path, image, noindex])
}
